module.exports = __webpack_public_path__ + "img/ic_32_exercises_mobility.e7019790.svg";